<div class="container-generic">

    <app-menu [menuModuleEnum]='menuModuleEnum' [menuFunctionalityEnum]='menuFunctionalityEnum'></app-menu>

    <div class="container-body">
        <div class="row">
            <div class="col-12 col-md-4">
                <h1>Logs Message Queue</h1>
            </div>
        </div>
        <div class="white-body">
            <div class="filters">
                <div class="row">
                    <div class="col-12 col-md-6 col-lg-3">
                        <mat-form-field appearance="outline">
                            <mat-icon matPrefix class="my-icon">search</mat-icon>
                            <mat-label>Pesquisar</mat-label>
                            <input matInput type="text" id="searchText" name="searchText" [(ngModel)]="searchText">
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3">
                        <mat-form-field appearance="outline">
                            <mat-label>Tipos de logs</mat-label>
                            <mat-select [(ngModel)]="messageType">
                                <mat-option [value]="null">Nenhum</mat-option>
                                <mat-option *ngFor="let item of listMessageType" [value]="item">
                                    {{ item }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3">
                        <mat-form-field appearance="outline">
                            <mat-label>ID HealthUnit</mat-label>
                            <mat-select [(ngModel)]="idHealthUnit">
                                <mat-option [value]="null">Nenhum</mat-option>
                                <mat-option *ngFor="let idHealthUnit of listIdHealthUnit" [value]="idHealthUnit">
                                    {{ idHealthUnit }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3">
                        <mat-form-field appearance="outline">
                            <mat-label>Data</mat-label>
                            <input [(ngModel)]="selectedPeriod" matInput [matDatepicker]="picker" disabled>
                            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker disabled="false"></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-md-12 col-lg-12 col-xl-6 button-filter-clean">
                        <div class="button-filter col-6 col-md-3">
                            <button type="submit" mat-flat-button class="btn-primary btn-block organize-button"
                                (click)="search(0)">
                                <span *ngIf="isLoading == false">Filtrar</span>
                                <mat-icon *ngIf="isLoading == false">filter_alt</mat-icon>
                                <mat-spinner [diameter]="30" class="mat-spinner-btn white-spinner"
                                    *ngIf="isLoading == true">
                                </mat-spinner>
                            </button>
                        </div>
                        <div class="button-clean col-6 col-md-3">
                            <button type="button" mat-flat-button color="accent" class="btn-secundary organize-button"
                                (click)="cancel()">
                                <span *ngIf="isLoading == false">Cancelar</span>
                                <mat-icon *ngIf="isLoading == false">cleaning_services</mat-icon>
                                <mat-spinner [diameter]="30" class="mat-spinner-btn" *ngIf="isLoading == true">
                                </mat-spinner>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="table-padding" *ngIf="!isLoading">
                <app-table [columns]="columns" [list]="listLog" (actionClicked)="logDetails($event)"
                    [isLoading]="isLoading"></app-table>
            </div>

            <app-loading-list *ngIf="isLoading"></app-loading-list>

            <div class="row">
                <div class="col-12 col-sm-12 col-md-12">
                    <mat-paginator [length]="this.fullListSize" #paginator [pageIndex]="0" [pageSize]="30"
                        aria-label="Select page" (page)="changePage($event)">
                    </mat-paginator>
                </div>
            </div>
        </div>
    </div>
</div>